module.exports = __webpack_public_path__ + "static/media/IMG_2984.d2e5167a.jpg";